import taskBoardComponent from './task-board.component';

const taskBoardModule = angular.module('taskBoard', [
])
  .component('taskBoard', taskBoardComponent)
  .name;

export default taskBoardModule;
